module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Trendbewertung","progress":"Bewertungsfortschritt"},"en":{"title":"Trend evaluation","progress":"Evaluation progress"}}')
  delete Component.options._Ctor
}
